// extracted by mini-css-extract-plugin
export default {"root":"QrM6hX1K0OG7aKWIX4mZ","title":"d04WCieG7G3rasFNMqI7","content":"wypQjLBHYhrgGgXf7atR"};